<template>
  <nav>
    <ul class="flex justify-center gap-8">
      <li v-for="tab in appTabs" :key="tab.app">
        <button
          type="button"
          class="text-static-white-80 relative flex flex-col items-center justify-center gap-1 text-center text-xs font-medium"
          @click="switchApp(tab.app)"
        >
          <span
            class="block size-14 backdrop-blur-sm [clip-path:inset(0_round_16px)]"
          >
            <component
              :is="activeApp === tab.app ? tab.activeIcon : tab.inactiveIcon"
              class="block size-14"
            />
          </span>
          <span
            v-if="tab.app === FlowType.HOTELS"
            class="text-static-white text-2xs from-text-negative-primary to-text-negative-accent absolute -top-2 block h-[17px] w-[35px] rounded-full bg-gradient-to-b px-1 py-0.5 font-medium leading-none"
          >
            new
          </span>
          <span class="block">{{ tab.label }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { FlowType } from '../../shared/config';
  import AviaActiveIcon from './assets/avia-active.svg?component';
  import AviaInactiveIcon from './assets/avia-inactive.svg?component';
  import RwActiveIcon from './assets/rw-active.svg?component';
  import RwInactiveIcon from './assets/rw-inactive.svg?component';
  import ToursActiveIcon from './assets/tours-active.svg?component';
  import ToursInactiveIcon from './assets/tours-inactive.svg?component';
  // import HotelsActiveIcon from './assets/hotels-active.svg?component';
  // import HotelsInactiveIcon from './assets/hotels-inactive.svg?component';

  const props = defineProps<{ activeApp: FlowType; sourcePage?: string }>();
  const emit = defineEmits<{
    onMiniAppSwitch: [app: FlowType];
  }>();

  const { t } = useI18n();

  const appTabs = computed(() => [
    {
      app: FlowType.AVIA,
      qaId: `${props.sourcePage}.appSwitch.avia`,
      label: t('appSwitchButton.avia'),
      activeIcon: AviaActiveIcon,
      inactiveIcon: AviaInactiveIcon,
    },
    {
      app: FlowType.RAILWAYS,
      qaId: `${props.sourcePage}.appSwitch.railways`,
      label: t('appSwitchButton.railways'),
      activeIcon: RwActiveIcon,
      inactiveIcon: RwInactiveIcon,
    },
    {
      app: FlowType.TOURS,
      qaId: `${props.sourcePage}.appSwitch.tours`,
      label: t('appSwitchButton.tours'),
      activeIcon: ToursActiveIcon,
      inactiveIcon: ToursInactiveIcon,
    },
    // {
    //   app: FlowType.HOTELS,
    //   qaId: `${props.sourcePage}.appSwitch.hotels`,
    //   label: t('appSwitchButton.hotels'),
    //   activeIcon: HotelsActiveIcon,
    //   inactiveIcon: HotelsInactiveIcon,
    // },
  ]);

  function switchApp(appName: FlowType) {
    /** To prevent reopening active app */
    const isTryingToOpenActiveApp = appName === props.activeApp;

    if (!isTryingToOpenActiveApp) {
      emit('onMiniAppSwitch', appName);
    }
  }
</script>

<i18n src="./config/locales.json"></i18n>
